<div>
  <button mat-icon-button (click)="set()">
    <mat-icon>
      @if (dark) {
        light_mode
      } @else {
        dark_mode
      }
    </mat-icon>
  </button>
</div>